import { computed } from 'vue';
import useLatchkeyStore from '~/stores/useLatchkeyStore';
import { useTitle } from '@vueuse/core';
import useUpc from '~/modules/upc/composables/useUpc';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import { useBrand } from '~/composables/useBrand';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useProductType } from '~/composables/useProductType';

export default function useConsolidatedProductDetails() {
  const { isConsolidatedPage } = useProductType();

  if (isConsolidatedPage) {
    const { productData } = useProduct();
    const { selectedUpcId } = useUpc();
    const { isMcom } = useBrand();
    const { isLilyAIEnabledFlag } = useProductFlags();
    const { lilyAIAttributesEnabled } = useKillswitches();

    const store = useLatchkeyStore();
    const firstUpcIdForSelectedLatchkey = computed(() => store.firstUpcIdForSelectedLatchkey);
    const upcIdSource = computed(() => selectedUpcId.value || firstUpcIdForSelectedLatchkey.value);
    const productDetail = computed(() => productData.relationships?.upcs?.[upcIdSource.value]?.detail);
    const productName = computed(() => productDetail.value?.name || '');
    const productExclusiveName = computed(() => productDetail.value?.exclusiveName || '');

    if (isMcom && !lilyAIAttributesEnabled && !isLilyAIEnabledFlag) {
      const { productName: nameRaw, brandName, secondaryDescription } = useCommonProductGetters();

      const updatedProductName = computed(() => productName.value || nameRaw);

      const consolidatedTitle = computed(() => {
        let titleTag = `${brandName || ''} ${secondaryDescription} ${updatedProductName.value}`.trim();
        titleTag += " - Macy's";
        return titleTag;
      });
      useTitle(consolidatedTitle);
    }

    return {
      selectedUpcDetail: productDetail,
      productName,
      productExclusiveName,
    };
  }
  return {
    selectedUpcDetail: computed(() => undefined),
    productName: computed(() => ''),
    productExclusiveName: computed(() => ''),
  };
}
